var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello",style:({position:_vm.fixed,left:_vm.clientX-400+'px',top:_vm.clientY+110+'px'})},[_c('div',{directives:[{name:"drag",rawName:"v-drag"}],attrs:{"id":"orderTime"}})])}
var staticRenderFns = []

export { render, staticRenderFns }